export default "__VITE_ASSET__BawJGuks__"